import { render, staticRenderFns } from "./QuoteHistory.vue?vue&type=template&id=3762cce6&scoped=true"
import script from "./QuoteHistory.vue?vue&type=script&lang=js"
export * from "./QuoteHistory.vue?vue&type=script&lang=js"
import style0 from "./QuoteHistory.vue?vue&type=style&index=0&id=3762cce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762cce6",
  null
  
)

export default component.exports